import { useEffect, useState } from "preact/hooks";
import { IoIosCloseCircleOutline, IoIosCheckmarkCircle } from "react-icons/io";
import { BiSolidBadgeCheck, BiDownload, BiLoaderAlt } from "react-icons/bi";
import useCertStore from "../../store";

const Verified = ({ id, show, onClose, onLoaded, onDownload }) => {
  const [validationData, setValidationData] = useState(null);
  const [visibleStep, setVisibleStep] = useState(0);

  useEffect(() => {
    if (show) {
      setVisibleStep(0);
      fetch(
        `https://6vqysb58ek.execute-api.us-east-1.amazonaws.com/prod/validate?credential=${id}`,
        { method: "POST", headers: { "Content-Type": "application/json" } },
      )
        .then((res) => (res.ok ? res.json() : null))
        .then((data) => {
          if (data && data.validationResult) {
            setValidationData(data.validationResult);
          }
        })
        .catch((err) => {
          console.error("Verification failed:", err);
        })
        .finally(() => {
          if (onLoaded) {
            onLoaded();
          }
        });
    }
  }, [show, id]);

  useEffect(() => {
    if (validationData && show) {
      const interval = setInterval(() => {
        setVisibleStep((prev) => {
          if (prev < 5) return prev + 1;
          clearInterval(interval);
          return prev;
        });
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [validationData, show]);

  if (!show || !validationData) {
    return null;
  }

  //   const { issuer, subject, credential } = validationData;
  //   const blockchainId = credential.id.split(":").pop();

  return (
    <div
      class="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center"
      onClick={onClose}
    >
      <div
        class="bg-white rounded-lg shadow-2xl p-6 m-4 w-[90%] mx-auto md:w-[555px] relative max-h-[90vh] overflow-y-auto overflow-x-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        <button onClick={onClose} class="absolute top-4 right-4">
          <IoIosCloseCircleOutline class="w-6 h-6 text-gray-600" />
        </button>

        <h2 class="text-2xl font-bold text-center my-6">
          Verificación de Credencial
        </h2>

        <div class="space-y-4">
          <div class="flex justify-between items-center border-b pb-2">
            <div>
              <p class="text-sm text-[#952415]">Organización emisora</p>
              <p class="font-semibold text-[#616161]">
                {validationData.issuer_name}
              </p>
            </div>
            {visibleStep >= 1 ? (
              <BiSolidBadgeCheck
                color="#60a5fa"
                class="w-6 h-6 animate-in fade-in zoom-in duration-300"
              />
            ) : (
              <BiLoaderAlt class="w-6 h-6 animate-spin text-gray-400" />
            )}
          </div>

          <div class="flex justify-between items-center border-b pb-2">
            <div>
              <p class="text-sm text-[#952415]">Emitido a</p>
              <p class="font-semibold text-[#616161]">
                {validationData.full_name}
              </p>
            </div>
            {visibleStep >= 2 ? (
              <IoIosCheckmarkCircle
                color="#01a622"
                class="w-6 h-6 animate-in fade-in zoom-in duration-300"
              />
            ) : (
              visibleStep >= 1 && (
                <BiLoaderAlt class="w-6 h-6 animate-spin text-gray-400" />
              )
            )}
          </div>

          <div class="flex justify-between items-center border-b pb-2">
            <div>
              <p class="text-sm text-[#952415]">Fecha de emisión</p>
              <p class="font-semibold text-[#616161]">
                {new Date(validationData.issuance_date).toLocaleDateString(
                  "es-ES",
                  {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                  },
                )}
              </p>
            </div>
            {visibleStep >= 3 ? (
              <IoIosCheckmarkCircle
                color="#01a622"
                class="w-6 h-6 animate-in fade-in zoom-in duration-300"
              />
            ) : (
              visibleStep >= 2 && (
                <BiLoaderAlt class="w-6 h-6 animate-spin text-gray-400" />
              )
            )}
          </div>

          <div class="flex justify-between items-center border-b pb-2">
            <div>
              <p class="text-sm text-[#952415]">Fecha de aceptación</p>
              <p class="font-semibold text-[#616161]">
                {new Date(validationData.valid_from).toLocaleDateString(
                  "es-ES",
                  {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                  },
                )}
              </p>
            </div>
            {visibleStep >= 4 ? (
              <IoIosCheckmarkCircle
                color="#01a622"
                class="w-6 h-6 animate-in fade-in zoom-in duration-300"
              />
            ) : (
              visibleStep >= 3 && (
                <BiLoaderAlt class="w-6 h-6 animate-spin text-gray-400" />
              )
            )}
          </div>
          <div class="flex justify-between items-center border-b pb-2">
            <div>
              <p class="text-sm text-[#952415] w-[70%] md:w-[338px]">
                Esta credencial ha sido verificada a través de OpenID Connect.
              </p>
              <p class="font-semibold text-[#616161] w-[70%] md:w-[390px]">
                La firma digital es válida y puede consultarse en:
                verified.mayahii.com
              </p>
            </div>
            {visibleStep >= 5 ? (
              <IoIosCheckmarkCircle
                color="#01a622"
                class="w-6 h-6 shrink-0 animate-in fade-in zoom-in duration-300"
              />
            ) : (
              visibleStep >= 4 && (
                <BiLoaderAlt class="w-6 h-6 shrink-0 animate-spin text-gray-400" />
              )
            )}
          </div>

          {/* <div class="flex justify-between items-center border-b pb-2">
            <div>
              <p class="text-sm text-gray-500">Credencial verificada en:</p>
              <p class="font-semibold break-all">Blockchain ID</p>
              <p class="font-mono text-xs break-all">{blockchainId}</p>
            </div>
            <BiSolidBadgeCheck color="#60a5fa" class="w-6 h-6" />
          </div> */}
        </div>

        {visibleStep >= 5 && (
          <>
            <p class="text-center text-[#01a622] mt-6 text-[24px] border-b pb-2 animate-in fade-in slide-in-from-bottom-2 duration-500">
              Credencial Verificada
            </p>

            <div class="flex justify-center mt-[30px] pb-2 animate-in fade-in slide-in-from-bottom-2 duration-500 delay-100">
              <button
                onClick={onDownload}
                class="flex items-center justify-center px-6 py-2 bg-[#952415] text-white rounded-md hover:bg-[#6b0b18] transition-colors"
              >
                <BiDownload class="w-5 h-5 mr-2" />
                Descargar credencial
              </button>
            </div>
            <div class="flex justify-end items-center gap-2 mt-4 animate-in fade-in duration-500 delay-200">
              <img
                className="w-[60px] h-[20px]"
                src="https://d1g6c01s9ssd7h.cloudfront.net/img/OpenID.png"
                alt="OpenID"
              />
              <img
                className="w-[20px] h-[20px]"
                src="https://d1g6c01s9ssd7h.cloudfront.net/img/OpenBadgesStandar.png"
                alt="OpenBadges"
              />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Verified;
